import { Heading } from "@chakra-ui/react";
import { FC } from 'react';

export const HeadingIdentity: FC = ({ children }) => (
  <Heading
    as="h1"
    size="lg"
    textAlign="center"
    marginTop={2}
    marginBottom={0}
  >
    {children}
  </Heading>
);
 